import { type NodeProps } from "@solidtv/solid";
import { LandscapeThumbnail } from "./index";
import { createSignal } from "solid-js";

interface EpisodeCardProps extends NodeProps {
  item: any;
  onEnter: () => void;
}

const transitionObj = {
  duration: 200,
  easing: "ease-out"
};

export default function EpisodeCard(props: EpisodeCardProps) {
  const [focused, setFocused] = createSignal(false);

  return (
    <view
      {...props}
      width={320}
      height={180}
      onEnter={props.onEnter}
      onFocusChanged={setFocused}
      scale={focused() ? 1.08 : 1}
      transition={{ scale: transitionObj }}
      zIndex={focused() ? 10 : 1}
      forwardStates
    >
      <LandscapeThumbnail item={props.item} width={320} height={180} />
      {/* Border overlay */}
      <view
        width={320}
        height={180}
        border={{ width: focused() ? 4 : 0, color: 0xffffffff }}
        color={0x00000000}
        transition={{ border: transitionObj }}
        zIndex={2}
      />
      {/* Dim overlay for unfocused state to make focused pop more */}
      <view
        width={320}
        height={180}
        color={focused() ? 0x00000000 : 0x00000066}
        transition={{ color: transitionObj }}
        zIndex={3}
      />

      <text y={195} fontSize={22} maxLines={1} contain="width" width={320} color={focused() ? 0xffffffff : 0xccccccff}>
        {props.item.title}
      </text>
    </view>
  );
}
